﻿import React, {FC} from 'react';
import {MenuItem, Select, SelectProps} from "@mui/material";
import {SearchSupplierSortType} from "../../../../../types/supplier/SearchSupplierSortType";
import styled from "@mui/system/styled";

// because generic types with styled components is broken, i duplicated the code here
const SearchFilterDropDown = styled(Select<SearchSupplierSortType>)(({theme}) => ({
  width: '18em',
  [theme.breakpoints.down('lg')]: {
    width: '20em',
  },
  [theme.breakpoints.down('sm')]: {
    width: "100%",
  },
  '& .MuiChip-filledDefault .MuiChip-labelSmall': {
    fontSize: '0.8em !important',
    padding: '0em 0.4em !important'
  },
}));

const SearchSortBySelect: FC<SelectProps<SearchSupplierSortType>> = (props) => {
  return <SearchFilterDropDown size='small' {...props}>
    <MenuItem value={'distance'}>Distance</MenuItem>
    <MenuItem value={'monthly-rate-low'}>Monthly Rate Low</MenuItem>
    <MenuItem value={'monthly-rate-high'}>Monthly Rate High</MenuItem>
    <MenuItem value={'daily-rate-low'}>Daily Rate Low</MenuItem>
    <MenuItem value={'daily-rate-high'}>Daily Rate High</MenuItem>
  </SearchFilterDropDown>
}

export default SearchSortBySelect;
